module.exports = __webpack_public_path__ + "img/about-us-top.f18cf6c1.png";